module.exports = __webpack_public_path__ + "static/media/Wheel-git.2afe8e61.png";